import { render, staticRenderFns } from "./full-card.vue?vue&type=template&id=286ce132"
import script from "./full-card.vue?vue&type=script&lang=js"
export * from "./full-card.vue?vue&type=script&lang=js"
import style0 from "./full-card.vue?vue&type=style&index=0&id=286ce132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports